import { queryExecutor } from '@/_core/cqrs';
import { GetUserStatisticsQuery } from '@/api/tracking/queries';
import { TrackingClient } from './trackingClient';
import { IntercomDestinationFilter } from './destinationFilters/intercomDestinationFilter';
import { TrackedPage } from './trackedpages';
import { TrackedEvent } from './trackedEvent';
import { UserActionTrackEvent, PageVisitTrackEvent } from './types';
import { ActiveCampaignDestinationFilter } from './destinationFilters/activeCampaignDestinationFilter';

class TrackingService {
    //Do NOT ascess this... use CreateOrGetClient !!
    private client: TrackingClient = null;
    private clientInicializer: Promise<boolean> = null;

    public async TrackSimplePageVisit(page: TrackedPage) {
        const client = await this.CreateOrGetClient();
        const pageName = TrackedPage[page];
        client.registerPageVisit(pageName, {});
    }

    public async TrackPageVisit(pageVisit: PageVisitTrackEvent) {
        const client = await this.CreateOrGetClient();

        client.registerPageVisit(pageVisit.pageName, pageVisit.properties);
    }

    public async TrackSubpageView(subPage: TrackedPage) {
        const client = await this.CreateOrGetClient();

        client.registerPageVisit(TrackedPage[subPage]);
    }

    public async TrackSignUp(signupKind: string, fromStorymap: boolean) {
        const client = await this.CreateOrGetClient();
        const kind = signupKind !== '1' ? signupKind : fromStorymap ? 'fromPublicMap' : 'regular';

        client.registerEvent(TrackedEvent.UserSignedUp, { signupKind: kind });
        client.registerVirtualPageVisit('/signupsuccess', TrackedPage[TrackedPage.SignupSuccess]);
    }

    public async TrackUserAction(userAction: UserActionTrackEvent) {
        const client = await this.CreateOrGetClient();

        client.registerEvent(userAction.event, userAction.properties);
    }

    private async InitClient(): Promise<boolean> {
        if (this.client == null) {
            const res = await queryExecutor.executeQuery(new GetUserStatisticsQuery());
            this.client = new TrackingClient(initAppData.trackingTools.segmentWriteKey, res, [new IntercomDestinationFilter(), new ActiveCampaignDestinationFilter()]);

            this.client.startTracking();
        }
        return true;
    }

    private async CreateOrGetClient(): Promise<TrackingClient> {
        if (this.client == null) {
            if (this.clientInicializer == null) {
                this.clientInicializer = this.InitClient();
            }

            await this.clientInicializer;
        }

        return this.client;
    }
}

export const trackingService = new TrackingService();
